import customSelect from "custom-select";

function makeSelects() {
  //If you are her because you want to know how to prevent your select from being transformed by this plugin: add class="preventTransfrom"
  customSelect("select:not(.preventTransform", {
    containerClass: "select",
    openerClass: "select__opener",
    panelClass: "select__panel",
    optionClass: "select__option",
    optgroupClass: "select__optgroup"
  });
}

$(document).ready(function() {
  makeSelects();
});
